/* SLIDE UP */
let slideUp = (target, duration=500) => {

  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
  }, duration);
}

/* SLIDE DOWN */
let slideDown = (target, duration=500) => {

  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

/* TOOGLE */
var slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}


customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.drawer = document.getElementById('menu-drawer');
    this.openButtons = document.querySelectorAll('.js-open-menu');
    this.closeButtons = document.querySelectorAll('.js-close-menu');
    this.dropdowns = document.querySelectorAll('button.menu-drawer__menu-item')
    
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeMenuDrawer());
    this.bindEvents();

    const menuChildren = document.querySelectorAll(".menu-drawer__menu-item__child");

    menuChildren.forEach(child => {
      const back = child.querySelector(".child-title");
      back.addEventListener("click", this.closeTopDropdown.bind(this));
    });


    // Open grandchildren
    const childLinks = document.querySelectorAll(".child-link");
    childLinks.forEach(link => {
      link.addEventListener("click", this.openSecondDropdown.bind(this));
    });

    // Close grandchildren
    const menuGrandchildren = document.querySelectorAll(".menu-drawer__menu-item__grandchild");

    menuGrandchildren.forEach(grandchild => {
      const back = grandchild.querySelector(".grandchild-title");
      back.addEventListener("click", this.closeSecondDropdown.bind(this));
    });
  }

  bindEvents() {
    this.openButtons.forEach(openBtn => openBtn.addEventListener('click', this.openMenuDrawer.bind(this)));
    this.closeButtons.forEach(closeBtn => closeBtn.addEventListener('click', this.closeMenuDrawer.bind(this)));
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.dropdowns.forEach(dropdown => dropdown.addEventListener('click', this.openTopDropdown.bind(this)));


  }

  openMenuDrawer() {
    const fromTop = document.querySelector('.header').offsetHeight + document.querySelector('.header').getBoundingClientRect().top;
    this.drawer.style.top = `${fromTop}px`;
    document.body.style.overflow = 'hidden';

    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    document.body.addEventListener('click', this.onBodyClick);

    document.querySelector('.menu-drawer-container .js-open-menu').style.display = 'none';
    document.querySelector('.menu-drawer-container .js-close-menu').style.display = 'block';

    document.getElementById('shopify-section-header').classList.add('menu-open');
  }

  closeMenuDrawer() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);
    document.body.style.overflow = 'scroll';

    document.body.removeEventListener('click', this.onBodyClick);

    document.querySelector('.menu-drawer-container .js-close-menu').style.display = 'none';
    document.querySelector('.menu-drawer-container .js-open-menu').style.display = 'block';

    document.getElementById('shopify-section-header').classList.remove('menu-open');

    const children = document.querySelectorAll(".menu-drawer__menu-item__child");
    const grandchildren = document.querySelectorAll(".menu-drawer__menu-item__grandchild");

    children.forEach(child => {
      child.classList.remove('active');
    });

    grandchildren.forEach(child => {
      child.classList.remove('active');
    });
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay')) {
      this.closeMenuDrawer();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }

  openTopDropdown(evt){
    evt.stopImmediatePropagation(); 
    const dropdown = evt.currentTarget;
    const container = dropdown.closest('.menu-drawer__content');
    const children = container.querySelectorAll(".menu-drawer__menu-item__child");

    children.forEach(child => {
      if(child.dataset.index === dropdown.dataset.index){
        child.classList.add('active');
      }
    });
  }
  
  closeTopDropdown(evt){
    evt.stopImmediatePropagation(); 
    const dropdown = evt.currentTarget;
    const content = dropdown.closest('.menu-drawer__menu-item__child');
    content.classList.remove('active');
  }

  openSecondDropdown(evt){
    evt.stopImmediatePropagation(); 
    const dropdown = evt.currentTarget;
    const container = dropdown.closest('.menu-drawer__content');
    const grandChildren = container.querySelectorAll(".menu-drawer__menu-item__grandchild");

    grandChildren.forEach(grandchild => {
      if(grandchild.dataset.index === dropdown.dataset.index){
        grandchild.classList.add('active');
      }
    });
  }
  
  closeSecondDropdown(evt){
    evt.stopImmediatePropagation(); 
    const dropdown = evt.currentTarget;
    const content = dropdown.closest('.menu-drawer__menu-item__grandchild');
    content.classList.remove('active');
  }

  handleDropdowns(evt) {
    evt.stopImmediatePropagation(); 
    const dropdown = evt.currentTarget;

    if (dropdown.classList.contains('active')) {
      dropdown.classList.remove('active');
      slideUp(dropdown.nextElementSibling, 350);
    } else {
      dropdown.classList.add('active');
      slideDown(dropdown.nextElementSibling, 350);
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.sectionId}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;

    window.productSlider.slideToLoop(Number(newMedia.dataset.index));
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateSubscribeButtons(section, price) {
    const subscribe_buttons = document.querySelectorAll(`[data-section='${section}'][data-subscribe-button] [data-product-price]`)
    if( !subscribe_buttons ) return;
    subscribe_buttons.forEach( button => {
      button.innerText = price
    })
  }

  disableSubscribeButtons(section, disable, available) {
    const subscribe_buttons = document.querySelectorAll(`[data-section='${section}'][data-subscribe-button]`)
    if( !subscribe_buttons ) return;
    subscribe_buttons.forEach( button => {
      disable ? button.querySelector('[data-product-price]').style.display = "none" : button.querySelector('[data-product-price]').style.display = "block"
      if( !disable && available ) button.removeAttribute("disabled")
      if( disable || !available ) button.setAttribute("disabled", "disabled")
    })
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      if( productForm.querySelector("#skio_container")){
        const input = productForm.querySelector('input[name="id"]') || productForm.querySelector('select[name="id"]');
        const skio_variant_id = productForm.querySelector(`select[name="id"] option[base-selected="${this.currentVariant.id}"`).value;
        const skio_variant_price = productForm.querySelector(`select[name="id"] option[base-selected="${this.currentVariant.id}"`).getAttribute("subscription-price");
        const skio_variant_price_old = productForm.querySelector(`select[name="id"] option[base-selected="${this.currentVariant.id}"`).getAttribute("subscription-price-old");
        input.value = skio_variant_id;
        input.dispatchEvent(new Event('change', { bubbles: true }));

        const sellingPlanInput = productForm.querySelector('select[name="selling_plan"]');
        const skio_selling_plan_id = productForm.querySelector(`select[name="selling_plan"] option[base-selected="${ this.currentVariant.id }"]`).value;
        sellingPlanInput.value = skio_selling_plan_id;
        sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));

        if ( productForm.querySelector('[data-product-price]') ){
          productForm.querySelector('[data-product-price]').innerHTML = skio_variant_price
        }

        const product_id = productForm.querySelector("#skio_container").getAttribute("data-product-id");

        let subscription_selector;
        let price_old;

        if(productForm.closest("[data-product]").nextElementSibling) {
          subscription_selector = productForm.closest("[data-product]").nextElementSibling.querySelector(`subscription-selection[data-section='${this.dataset.subscribeLink}'] label[data-product-id='${ productForm.closest("product-form").getAttribute("id").split("sub-").pop() }']`)
          price_old = productForm.closest("[data-product]").nextElementSibling.querySelector(`subscription-selection[data-section='${this.dataset.subscribeLink}'] label[data-product-price-id]`)
        } else {
          subscription_selector = productForm.closest("[data-product]").querySelector(`subscription-selection[data-section='${this.dataset.subscribeLink}'] label[data-product-id='${ productForm.closest("product-form").getAttribute("id").split("sub-").pop() }']`)
          price_old = productForm.closest("[data-product]").querySelector(`subscription-selection[data-section='${this.dataset.subscribeLink}'] label[data-product-price-id='${ productForm.closest("product-form").getAttribute("id").split("sub-").pop() }']`)
        }

        if( subscription_selector ){
          // get the current value of the input
          let current_value = subscription_selector.querySelector("input").getAttribute("value");
          let old_value = price_old.querySelector("input").getAttribute("value");
          let parsed_value = JSON.parse(current_value);
          let parsed_old_value = JSON.parse(old_value);
          // if the current price is different than the new variant price 
          if ( parsed_value.price != skio_variant_price ){
            // update the value of the input with price
            parsed_value.price = skio_variant_price;
            parsed_old_value.price = skio_variant_price_old;
            subscription_selector.querySelector("input").setAttribute("value", JSON.stringify(parsed_value));
            price_old.querySelector("input").setAttribute("value", JSON.stringify(parsed_old_value));
            subscription_selector.querySelector("[data-subscription-price]").innerText = skio_variant_price;
            subscription_selector.querySelector("[data-subscription-price-old]").innerText = skio_variant_price_old;
            price_old.querySelector("[data-product-price]").innerText = `${currency}${(Number(Math.ceil(this.currentVariant.price * .01)))}`;

            //if option is checked, update the subscription buttons and display
            if(subscription_selector.querySelector("input:checked")){
              this.updateSubscribeButtons(this.dataset.subscribeLink, parsed_value.price);
            }

          }
        }
        
      } else {
        const input = productForm.querySelector('input[name="id"]') || productForm.querySelector('select[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));

        let price = productForm.querySelector("button[name='add'] [data-product-price]")
        let compareAtPrice = productForm.querySelector("button[name='add'] [data-product-compare-price]")
        const currency = productForm.querySelector("[data-currency]").getAttribute("data-currency")

        if(price) {
          price.innerHTML = `${currency}${(Number(Math.ceil(this.currentVariant.price * .01)))}`;
        }

        if(compareAtPrice) {
          compareAtPrice.innerHTML = `${currency}${(Number(Math.ceil(this.currentVariant.compare_at_price * .01)))}`;
        }
      }
    });
    let disable_subscription = this.currentVariant.title.toLowerCase() == "refill" ? true : false;
    // this.disableSubscribeButtons(this.dataset.subscribeLink, disable_subscription, this.currentVariant.available);
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    let section_id = this.dataset.section.replace(`-${this.dataset.productid}`, "")
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${section_id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${section_id}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    const subscribeButtons = document.querySelectorAll(`[data-section='${this.dataset.productid}'][data-subscribe-button]`);
    if (!productForms) return;
    productForms.forEach( productForm => {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      
      if (!modifyClass) return;
    })

    if( subscribeButtons ){
      subscribeButtons.forEach( button => {
        if (disable) {
          button.setAttribute('disabled', 'disabled');
        } else {
          button.removeAttribute('disabled');
        }
      })
    }
  }

  setUnavailable() {
    const productFormButtons = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    if(!productFormButtons) return;
    productFormButtons.forEach( button => {
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
    })
    
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductCard extends HTMLElement {
  constructor() {
    super();

    
  }
}

customElements.define('product-card', ProductCard);

const SCB_ACTIVE_CLASS = 'is-active'
const SCB_LOADED_CLASS = 'is-loaded'

class StickyCtaBar extends HTMLElement {
  constructor() {
    super();

    this.isInPdp = this.dataset.inPdp === 'true'
    this.pdpFormWrapperEl = document.querySelector('#productFormWrapper')

    setTimeout(() => {
      this.classList.add(SCB_LOADED_CLASS)
    }, 300)

    if (!this.isInPdp) {
      setTimeout(() => {
        this.classList.add(SCB_ACTIVE_CLASS)
      }, 500)
    } else {
      document.addEventListener('scroll', this.scrollHandler.bind(this))
    }
  }

  scrollHandler () {
    if (!this.pdpFormWrapperEl) return

    const pdpFormBottom = this.pdpFormWrapperEl.getBoundingClientRect().bottom
    if (pdpFormBottom < 50) {
      this.classList.add(SCB_ACTIVE_CLASS)
      this.parentElement.classList.add(SCB_ACTIVE_CLASS)
    } else {
      this.classList.remove(SCB_ACTIVE_CLASS)
      this.parentElement.classList.remove(SCB_ACTIVE_CLASS)
    }
  }
}

customElements.define('sticky-cta-bar', StickyCtaBar);

/*============================================================================
  Functions
==============================================================================*/
function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}


/*================ Add To Cart ================*/
if (document.querySelector('.js-add-to-cart')) {
  document.querySelector('.js-add-to-cart').addEventListener('click', function(e) {
    e.preventDefault();

    const id = Number(this.dataset.id);

    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: 1
      }],
      sections: atcGetSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        atcGetSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document.querySelector('cart-drawer').open();
      });
  });
}

function atcGetSectionsToRender() {
  return [
    {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
  ];
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

/*================ Micromodal ================*/
MicroModal.init({
  // onShow: modal => console.info(`${modal.id} is shown`), // [1]
  onClose: modal => {if ( document.querySelector('.cart-drawer__recommended-products')){document.querySelector('.cart-drawer__recommended-products').style.zIndex = '0'}; if ( document.querySelector('.cart-drawer__recommended-products')){document.querySelector('.cart-drawer__recommended-products').style.padding = '0px 10px'}; if ( document.querySelector('.cart-drawer__form')){document.querySelector('.cart-drawer__form').style.removeAttribute = 'style'}; if ( document.querySelector("[data-cart-drawer-overlay]")){document.querySelector('[data-cart-drawer-overlay]').style.display = "none"}}, // [2]
  openClass: 'is-open',
  disableScroll: true
});

/*================ Email submission to Mailchimp ================*/
function emailSubmit($el, success, failure) {
  $container = $el;
  $container.on('submit', 'form.signup', function(e){
    e.preventDefault();
    var $el = $(e.target);
    var $container = $(e.delegateTarget);
    var $errorFeedback = $('.error-feedback', $container);
    var $successFeedback = $('.success-feedback', $container);
    var data = $el.serialize();
    var $email = $("input[type='email']", $el);
    var $submit = $("input[type='submit']", $el);

    $errorFeedback.hide();
    $successFeedback.hide();
    $container.attr('data-state', '');

    if (!$email[0].checkValidity()) {
      $errorFeedback.text('Please check your email address').show();
      $container.attr('data-state', 'error');
      return;
    }

    $email.prop('disabled', true);
    $submit.prop('disabled', true);
    return $.ajax({
      type: "GET",
      url: $el.attr("action").replace('/post', '/post-json'),
      data: data,
      cache: false,
      dataType: "jsonp",
      jsonp: "c",
      contentType: "application/json; charset=utf-8",
      error: function(error) {
        $email.prop('disabled', false);
        $submit.prop('disabled', false);

        $errorFeedback.text('An internal error has occured').show();

        $container.attr('data-state', 'error');
      },
      success: function(data) {
        $email.prop('disabled', false);
        $submit.prop('disabled', false);

        if ((data.result === "success") ||
          (data.msg && data.msg.indexOf("already subscribed") >= 0) ||
          (data.msg && data.msg.indexOf("too many recent signup requests") >= 0)
        ) {
          $container.attr('data-state', 'success');
          document.cookie = `email_collected=true;30`;
          $successFeedback.show();
          if(success){ success(); }
        } else {
          error = data.msg.split(' - ')[1];
          $errorFeedback.text(error).show();
          $container.attr('data-state', 'error');
          if (failure) { failure(); }
        }
      }
    });
  });
}

/*================ Accessibility ================*/
const handleFirstTab = (e) => {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing')

    window.removeEventListener('keydown', handleFirstTab)
    window.addEventListener('mousedown', handleMouseDownOnce)
  }
}

const handleMouseDownOnce = () => {
  document.body.classList.remove('user-is-tabbing')

  window.removeEventListener('mousedown', handleMouseDownOnce)
  window.addEventListener('keydown', handleFirstTab)
}

window.addEventListener('keydown', handleFirstTab)

// Body content section accordions

function bodyContentSections(){
  const bodyContentSections = document.querySelectorAll(".body-content-section");

  if (bodyContentSections){
    bodyContentSections.forEach(section => {
      const accordions = section.querySelectorAll(".accordion");

      if (accordions){
        accordions.forEach(accordion => {
          accordion.addEventListener("click", () => {
            accordion.classList.toggle("active");
          });
        });
      }
    });
  }
}

bodyContentSections();

// Content reveal
const contentReveals = document.querySelectorAll('.content-reveal');

if (contentReveals){
  // for each content reveal section
  contentReveals.forEach(element => {
    const blocks = element.querySelectorAll(".content-reveal__block");
    
    // for each block within a section
    blocks.forEach(block => {
      const trigger = block.querySelector(".block-trigger");

      trigger.addEventListener("click", () => {
        // Save if the clicked block is currently active or not
        let isActive = false;
  
        if (block.classList.contains('active')){
          isActive = true;
        }

        // Deactivate other blocks
        blocks.forEach(inactiveBlock => {
          inactiveBlock.classList.remove('active')
        });

        // Toggle block depending on current state
        if (isActive){
          block.classList.remove('active');
        } else {
          block.classList.add('active');
        }
      });
    });
  });
}